export default __webpack_public_path__ + "static/media/courses_graphic.98e201be.png";